// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"c3cb9ec5e1b93848","5763":"fc96159dc4e9e7ea","6893":"63f2bfa5c6efa698","6974":"35a3e3d34b638e4f","7222":"ec2e7bc7a907c4bb","7937":"8079d1c87402af68"}[chunkId] + ".js";
};